/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Button = (props) => {
    const styleButton = {
        width: props.autoWidth ? '100%' : props.width,
        maxWidth: props.maxWidth && props.maxWidth,
        minWidth: props.minWidth && props.minWidth,
        textAlign: props.textAlign && props.textAlign,
        height: props.height ? props.height : 40,
        backgroundColor: props.bgColor && props.bgColor,
        paddingLeft: props.paddingLeft || undefined,
        paddingRight: props.paddingRight || undefined,
        marginLeft: props.marginLeft || undefined,
        marginRight: props.marginRight || undefined
    };
    const newClassName = props.className ? `${ props.className } flow-btn` : 'flow-btn';
    const classButton = props.active ? `${ newClassName } active-btn` : newClassName;
    return (
        <button
            type={ props.type && props.type }
            id={ props.id ? props.id : `button-${ Math.random() * 1000 }` }
            className={ classButton }
            disabled={ props.disabled && 'disabled' }
            style={ styleButton }
            onClick={ props.onClick }>
            { props.icon ?
                <span className='icon-btn'>
                    { props.icon }
                </span> :
                <span
                    style={ {
                        fontSize: props.fontSize && props.fontSize,
                        color: props.textColor || undefined
                    } }>{ props.text }
                </span> }
        </button>
    );
};

Button.propTypes = {
    type: PropTypes.string,
    height: PropTypes.number,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    text: PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]),
    fontSize: PropTypes.number,
    onClick: PropTypes.func,
    autoWidth: PropTypes.bool,
    width: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
    icon: PropTypes.element,
    active: PropTypes.bool,
    textAlign: PropTypes.string,
    bgColor: PropTypes.string,
    maxWidth: PropTypes.number,
    paddingLeft: PropTypes.number,
    paddingRight: PropTypes.number,
    marginLeft: PropTypes.number,
    marginRight: PropTypes.number,
    minWidth: PropTypes.number,
    textColor: PropTypes.string
};

export default Button;
